<template>
  <a-form ref="ruleFormAddress" :model="addressForm" :rules="rulesAddress" :label-col="labelCol"
    :wrapper-col="wrapperCol">
    <a-form-item ref="name" label="收货人" name="name">
      <a-input v-model:value="addressForm.name" placeholder='请输入收货人姓名' />
    </a-form-item>
    <a-form-item ref="phone" label="手机号" name="phone">
      <a-input v-model:value="addressForm.phone" placeholder='请输入收货人手机号' :maxlength="11" />
    </a-form-item>
    <a-form-item ref="province_content" label="收货地址" name="province_content">
      <a-cascader v-model:value="address" :field-names="{ label: 'name', value: 'id', children: 'children' }"
        :options="cityList" placeholder="请选择收货地址" @change="onChangeAddress" />
    </a-form-item>
    <a-form-item ref="address" label="详细地址" name="address">
      <a-input v-model:value="addressForm.address" placeholder='请输入详细地址' />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
      <a-button type="primary" @click="onSubmit" :loading="loading">
        保存
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { setEntityAddress, getEntityMore } from "@/api/qrcodeActivitys";
  import { message } from 'ant-design-vue';
  import { getArea } from "@/api/public";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    name: '',
    phone: '',
    province: '',
    city: '',
    district: '',
    address: '',
  }
  export default {
    name: 'addressChange',
    components: {},
    props: {
      scan_award_id: {
        type: Number
      },
    },
    setup(props, { emit }) {
      let province_content = async () => {
        if (!addressForm.value.province&&!addressForm.value.city&&!addressForm.value.district) {
          return Promise.reject("请选择收货地址");
        } else {
          return Promise.resolve();
        }
      };
      const addressForm = ref({ ...defForm });
      const state = reactive({
        cityList: [],
        address: [],
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 18 },
        rulesAddress: {
          name: [
            { required: true, message: '请输入收货人姓名' },
          ],
          phone: [
            { required: true, message: '请输入手机号' },
          ],
          province_content: [
            { required: true, validator: province_content },
          ],
          address: [
            { required: true, message: '请输入详细地址' },
          ],
        }
      });
      const ruleFormAddress = ref()
      const initData = async () => {
        let res = await getEntityMore(props.scan_award_id).then(res => res.data).catch(error => error);
        if (iscode(res)) {
          addressForm.value.name = res.data.receiv_name;
          addressForm.value.phone = res.data.receiv_phone;
          addressForm.value.address = res.data.receiv_address;
          addressForm.value.province = res.data.receiv_province_name;
          addressForm.value.city = res.data.receiv_city_name;
          addressForm.value.district = res.data.receiv_district_name;
          state.address = [Number(res.data.receiv_province_id), Number(res.data.receiv_city_id), Number(res.data.receiv_district_id)]
        } else {
          message.error(res.message);
        }
      };
      //获取省市区
      const getAreaList = async () => {
        let result = await getArea().then(res => res)
        state.cityList = result.data
      }
      //选择省市区
      const onChangeAddress = (e, options) => {
        addressForm.value.province = options[0].name
        addressForm.value.city = options[1].name
        addressForm.value.district = options[2].name
      }
      const onSubmit = () => {
        ruleFormAddress.value.validate().then(async () => {
          state.loading = true
          let res = await setEntityAddress({ ...addressForm.value, id: props.scan_award_id }).then(res => res.data).catch(error => error)
          if (iscode(res)) {
            emit("submitaddress");
            message.success(res.message);
          } else {
            message.error(res.message);
          }
          state.loading = false
        })
          .catch(error => {
            message.error('请完善表单！');
          });
      }
      onMounted(() => {
        getAreaList();
        initData();
      });
      return {
        addressForm,
        ...toRefs(state),
        ruleFormAddress,
        onSubmit,
        getAreaList,
        onChangeAddress
      }
    }
  }
</script>